import Header from '@/components/header/index.vue';
import Search from '@/components/search/index.vue';
import Menu from '@/components/menu/index.vue';
import Bottom from '@/components/bottom/index.vue';
import ProcessNavigation from '@/components/process-navigation/index.vue';

import Service from '@/service/index.js';

export default {
  components: {
    Header,
    Search,
    Menu,
    Bottom,
    ProcessNavigation
  },
  data() {
    return {
      id: '',
      oldId: '',
      processList: ['业务流程及准备材料', '编辑项目信息', '编辑受让资格', '上传附件信息', '重大事项提示', '承诺信息', '提交申请'],
      ruleForm: {
        type: '',
        name: '',
        idCard: '',
        mobile: '',
        householdsType: '',
        address: '',
        companyName: '',
        creditCode: '',
        email: '',
        legalName: '',
        legalMobile: '',
        legalIdType: '',
        legalIdCard: '',
        assignor: '',
        assignorIdType: '',
        assignorIdCard: '',
        assignorMobile: ''
      }
    };
  },
  created () {
    window.scrollTo(0, 0);
    this.id = this.$route.query.id;
    this.oldId = this.$route.query.oldId;
    Service.getUserBaseInfo().then(res => {
      if (!res.data) {
        return;
      }
      Object.keys(this.ruleForm).forEach((key) => {
        this.ruleForm[key] = res.data && String(res.data[key]);
      });
    });
  },
  methods: {
    next() {
      let str = '';
      if (this.id && this.oldId) {
        str = '?id=' + this.id + '&oldId=' + this.oldId;
      } else if (this.id) {
        str = '?id=' + this.id;
      } else if(this.oldId) {
        str = '?oldId=' + this.oldId;
      }
      this.$router.push('/publish-project/project-info' + str);
    },
    // 下载模版
    downTemplate(type) {
      if(type === 1) {
        window.open('/资产资源权属证明模板.pdf');
      } else {
        window.open('/关于同意资产再流转的意见.pdf');
      }
    }
  }
};
